var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetOwnApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#689F38"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7671 10.6651C12.7671 9.89191 13.3939 9.2651 14.1671 9.2651H25.8337C26.6069 9.2651 27.2337 9.89191 27.2337 10.6651V29.3318C27.2337 30.105 26.6069 30.7318 25.8337 30.7318H14.1671C13.3939 30.7318 12.7671 30.105 12.7671 29.3318V10.6651ZM14.1671 7.39844C12.3629 7.39844 10.9004 8.86097 10.9004 10.6651V29.3318C10.9004 31.1359 12.3629 32.5984 14.1671 32.5984H25.8337C27.6379 32.5984 29.1004 31.1359 29.1004 29.3318V10.6651C29.1004 8.86097 27.6379 7.39844 25.8337 7.39844H14.1671ZM20.0004 25.2484C19.0339 25.2484 18.2504 26.0319 18.2504 26.9984C18.2504 27.9649 19.0339 28.7484 20.0004 28.7484H20.0121C20.9786 28.7484 21.7621 27.9649 21.7621 26.9984C21.7621 26.0319 20.9786 25.2484 20.0121 25.2484H20.0004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetOwnApp);
export default __webpack_public_path__ + "static/media/get-own-app.cbca25af97805026df5912c76fed37c2.svg";
export { ForwardRef as ReactComponent };